import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Overrides } from '@material-ui/core/styles/overrides';

export const BadgeOverrides = (theme: Theme): Overrides => ({
  MuiBadge: {
    badge: {
      // Background color is set in the main component

      color: theme.palette.brand.contrastText,
    },
    dot: {
      // Position is set in the main component

      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: theme.palette.background.default,
      borderRadius: '50%',
    },
  },
});
